// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__ZYf69","revealHeader":"header_revealHeader__zsC2q","opaque":"header_opaque__cHfCI"};